// Category.$get() returns a shallow tree — [{ id, category, child: [...] }] — at
// most one level deep. Screens need a flat, render-ready list instead: the
// library and analytics use it for an id -> name lookup, the categories page
// uses `depth` to indent subcategories and `count` for the subcategory chip.
export function flattenCategories(categories) {
  const flat = [];

  (categories || []).forEach((parent) => {
    if (!parent) return;

    const children = Array.isArray(parent.child) ? parent.child : [];

    flat.push({
      id: parent.id,
      name: parent.category,
      depth: 0,
      parentId: null,
      count: children.length,
    });

    children.forEach((child) => {
      if (!child) return;
      flat.push({
        id: child.id,
        name: child.category,
        depth: 1,
        parentId: parent.id,
        count: 0,
      });
    });
  });

  return flat;
}

export default flattenCategories;
